import {React, useEffect, useState, useRef} from 'react';
import './GoogleMap.css';
import { Link } from 'react-router-dom';

const GoogleMapIframe = ({ city, height = 350 }) => {

	const iframeRef = useRef(null);
	const [mapSrc, setMapSrc] = useState('');

	useEffect(() => {
		if (!city) return;

		const src = `https://www.google.com/maps?q=${encodeURIComponent(city)}&output=embed`;
		setMapSrc(src);

	}, [city]);

	return (
        <div id='main_mapDiv'>
            <div className='module_map1'>
                    <h1>Sam's Tree Service</h1>
                    <h2>Expert Tree Service Solutions Across {city}</h2>
                    <h2>Specializing in Dangerous Trees</h2>
                    <h2>Proudly serving {city} and surrounding communities, including:</h2>
                     <h3><Link to="/tree_service_sarasota" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Sarasota</Link>, <Link to="/tree_service_bradenton" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Bradenton</Link>, <Link to="/tree_service_bradenton" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                West Bradenton</Link>, <Link to="/tree_service_siesta_key" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Siesta Key</Link>, <Link to="/tree_service_longboat_key" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Longboat Key</Link>, <Link to="/tree_service_lakewood_ranch" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Lakewood Ranch</Link>, <Link to="/tree_service_venice" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Venice</Link>, <Link to="/tree_service_englewood" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Englewood</Link>, <Link to="/tree_service_palmetto" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Palmetto</Link>, <Link to="/tree_service_parrish" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Parrish</Link>, <Link to="/tree_service_north_port" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                North Port</Link>, <Link to="/tree_service_punta_gorda" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Punta Gorda</Link>, <Link to="/tree_service_osprey" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Osprey</Link>, <Link to="/tree_service_palmer_ranch" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Palmer Ranch</Link>, <Link to="/tree_service_ruskin" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Ruskin</Link>, <Link to="/tree_service_stpete" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Saint Petersburg</Link>, <Link to="/tree_service_pinellas_park" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Pinellas Park</Link>, <Link to="/tree_service_riverview" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Riverview</Link>, <Link to="/tree_service_tampa" style={{ textDecoration: 'underline', color: 'inherit', fontWeight: '600' }}>
                                Tampa</Link>, and surrounding areas.</h3>

                 <p>Whether you're in a bustling neighborhood or a quieter, more rural area, we're ready to bring our top-notch services right to your doorstep.</p>   

            </div>
            <div className='module_map2'>
                
		        <iframe
			        ref={iframeRef}
			        title={`Map of ${city}`}
			        src={mapSrc}
			        width="100%"
			        height='100%'//{height}
			        style={{ border: 0, borderRadius: '12px' }}
			        loading="lazy"
			        referrerPolicy="no-referrer-when-downgrade"
		        />
                </div>
        </div>
	);
};

export default GoogleMapIframe;
